import React from 'react';
import { IconProps } from '../../../../assets/icons/types';
import classnames from 'classnames';

const ProfileIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={classnames('size-6', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="10" r="4" stroke={color ?? 'current-color'} strokeWidth="1.25" />
      <path
        d="M19 21C19 17.134 15.866 14 12 14C8.13401 14 5 17.134 5 21"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
      <circle cx="12" cy="12" r="11.375" stroke={color ?? 'current-color'} strokeWidth="1.25" />
      <circle cx="20.25" cy="4.25" r="2.75" fill="#00B927" stroke="white" />
    </svg>
  );
};

export default ProfileIcon;
